import { TextArrow } from "./TextArrow";

declare let THREE: any;

export class Label extends (THREE.Mesh as { new(geometry, material): any; }) {

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(-90));
  static readonly Name = 'Label';
  public imageWidth;
  public imageHeight;

  constructor() {
    const geometry = new THREE.PlaneBufferGeometry(1, 1).applyMatrix(Label.rotationTransform);
    const material = new THREE.MeshBasicMaterial({side: THREE.DoubleSide, transparent: true});
    super(geometry, material);
    this.name = Label.Name;
    this.imageWidth = 1;
    this.imageHeight = 1;
    // this.add(new TextArrow(new THREE.Vector3(0, 0, 0)));
  }

  private static makePowerOf2(image: HTMLImageElement): HTMLCanvasElement {

    const newWidth = THREE.Math.ceilPowerOfTwo(image.width);
    const newHeight = THREE.Math.ceilPowerOfTwo(image.height);
    const scaleW = newWidth / image.width;
    const scaleH = newHeight / image.height;

    const canvas = document.createElement('canvas');
    canvas.width = newWidth;
    canvas.height = newHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(image, 0, 0, image.width * scaleW, image.height * scaleH);

    return canvas;
  }

  onBeforeRender(renderer, scene, camera) {
    const scale = camera.scale.x;
    this.scale.set(this.imageWidth / 6, 1, this.imageHeight / 6);
    // this.parent.updateScale(scale);
  }

  update(image: HTMLImageElement) {

    const canvas = Label.makePowerOf2(image);

    if (!this.material.map) {
      this.material.map = new THREE.Texture(canvas);
    } else {
      this.material.map.image = canvas;
    }
    this.material.map.needsUpdate = true;
    this.material.needsUpdate = true;

    this.imageWidth = image.width;
    this.imageHeight = image.height;

    // const textArrow = this.children.filter(ch => ch instanceof TextArrow)[0];
    // textArrow.update(this.position);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Text/Label.ts